/**
 * client/src/lib/vault-titles.ts
 *
 * Canonical page-heading text for the two vault surfaces (#3388) — the SAME
 * string the primary nav uses for the link that gets you there
 * (`buildNavItems`, `client/src/components/layout/nav-items.ts`), so a click
 * always lands on a page whose own heading names the surface it navigated to,
 * never the generic "Identifiers" the two contexts previously shared.
 *
 * Its own module (adversarial-review MINOR 8) rather than an addition to
 * `terminology.ts`, which was already close to its document-budget cap.
 */
export const VAULT_PAGE_TITLES: Record<"personal" | "org", string> = {
  personal: "Personal Vault",
  org: "Org Vault",
};
